module.exports = __webpack_public_path__ + "img/google.09aea0f5.svg";